exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  background-size: cover !important;\n  /* background: linear-gradient(120deg, #fdfdfd, #90def6); */\n  background-repeat: no-repeat;\n}\n.login-page {\n  background-color: #fff;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main